module.exports = __webpack_public_path__ + "img/eraser20.b9c7cacc.png";